import { render, staticRenderFns } from "./NavettaReservationEditor.vue?vue&type=template&id=5fda2d52&scoped=true&"
import script from "./NavettaReservationEditor.vue?vue&type=script&lang=js&"
export * from "./NavettaReservationEditor.vue?vue&type=script&lang=js&"
import style0 from "./NavettaReservationEditor.vue?vue&type=style&index=0&id=5fda2d52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fda2d52",
  null
  
)

export default component.exports